
import { Component, OnInit } from '@angular/core';

import { GalleriaModule } from 'primeng/galleria';
import { CommonModule } from '@angular/common';
import { ImageModule } from 'primeng/image';


@Component({
  selector: 'app-food-gallery',
  standalone: true,

  templateUrl: './food-gallery.component.html',
  styleUrl: './food-gallery.component.scss',
  imports: [ ImageModule, GalleriaModule, CommonModule],
})
export class FoodGalleryComponent {

  displayCustom: boolean = false;

  activeIndex: number = 0;
  
  images: any[] | undefined;

ngOnInit() {
  const imageNames = [
    'platos 001.jpg',  'platos 007.jpg', 'platos 009.jpg','platos 071.jpg',
    'platos 013.jpg', 'platos 023.jpg', 'platos 030.jpg', 'platos 034.jpg',
    'platos 038.jpg', 'platos 042.jpg', 'platos 043.jpg', 'platos 048.jpg',
    'platos 054.jpg', 'platos 057.jpg', 'platos 061.jpg', 'platos 067.jpg',
    //  'platos 073.jpg', 'platos 076.jpg', 'platos 079.jpg',
    // 'platos 081.jpg', 'platos 091.jpg', 'platos 092.jpg', 'platos 094.jpg',
    // 'platos 101.jpg', 'platos 104.jpg' 'platos 004.jpg'
  ];

  this.images = imageNames.map((name, index) => ({
    previewImageSrc: `assets/img/gallery/1920/${name}`,
    thumbnailImageSrc: `assets/img/gallery/thumb/${name}`,
    alt: `Plato ${index + 1}`,
    title: `Plato ${index + 1}`,
    subtitle: '',
    href: '',
    class: `image${index + 1}`
  }));

  console.log(this.images);  // Verifica en consola que las rutas estén correctas
}

// responsiveOptions: any[] = [
//   {
//       breakpoint: '1500px',
//       numVisible: 5
//   },
//   {
//       breakpoint: '1024px',
//       numVisible: 3
//   },
//   {
//       breakpoint: '768px',
//       numVisible: 2
//   },
//   {
//       breakpoint: '560px',
//       numVisible: 1
//   }
// ];
// imageClick(index: number) {
//   this.activeIndex = index;
//   this.displayCustom = true;
// }


responsiveOptions: any[] = [
    {
        breakpoint: '1500px',
        numVisible: 5
    },
    {
        breakpoint: '1024px',
        numVisible: 3
    },
    {
        breakpoint: '768px',
        numVisible: 2
    },
    {
        breakpoint: '560px',
        numVisible: 1
    }
];




imageClick(index: number) {
  console.log(index);
  
    this.activeIndex = index;
    this.displayCustom = true;
}
}
